
import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, DOCUMENT, DestroyRef, ElementRef, OnDestroy, Renderer2, ViewChild, computed, effect, inject, input, model, signal, untracked, viewChild } from '@angular/core';
import { RouterModule } from '@angular/router';


import { Router } from '@angular/router';
import { CarouselComponent, CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
// Removed ReplaySubject import - using DestroyRef instead
import { LAYOUT_TYPE } from 'src/app/category/enum/category-page.enum';
import { CardLoaderComponent } from 'src/app/components/card-loader/card-loader.component';
import { StarRatingComponent } from 'src/app/components/star-rating/star-rating.component';
import { BrowserApiService } from 'src/app/core/services/browser-api/browser-api.service';
import { CartRepositoryService } from 'src/app/core/services/cart/cart-repository.service';
import { DeviceDetectionService } from 'src/app/core/services/device-detection/device-detection.service';
import { DomMutationObserverService } from 'src/app/core/services/dom-mutation-observer/dom-mutation-observer.service';
import { DomainNameService } from 'src/app/core/services/domain-name/domain-name.service';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { OverlayService } from 'src/app/core/services/overlay/overlay.service';
import { PlatformService } from 'src/app/core/services/platform/platform.service';
import { CategoryInfo, ClickActionChoices } from 'src/app/home/models/home.model';
import { GoogleReview } from 'src/app/home/models/review.interface';
import { HomeRepositoryService } from 'src/app/home/services/home-repository.service';
import { ClickActionForFlutter } from 'src/app/shared/class/link-handler.class';
import { InterpolationPipe } from 'src/app/shared/pipes/interpolation.pipe';
import { ReviewInterpolationPipe } from 'src/app/shared/pipes/review-interpolation.pipe';
import { SafehtmlPipe } from 'src/app/shared/pipes/safehtml.pipe';
import { GoogleReviewOverlayComponent } from '../google-review-overlay/google-review-overlay.component';
import { ScrollingTextComponent } from '../scrolling-text/scrolling-text.component';
import { DynamicHomeProductCardComponent } from './dynamic-home-product-card/dynamic-home-product-card.component';
import { MultipleCollectionProductListComponent } from './multiple-collection-product-list/multiple-collection-product-list.component';
import { SideBannerProductListComponent } from './primary-viewer-panel/side-banner-product-list/side-banner-product-list.component';

enum ComponentType {
  CAROUSEL = 'Carousel',
  CAROUSEL_LIST = 'Carousel-List',
  CAROUSEL_LAYOUT = 'Carousel-layout',
  REVIEW_LAYOUT = 'Review-layout'
}

const NIKITA_RETAILER_APP_DOMAIN = "nikitaretailer.hyperinvento.com"

// ðŸŽ¯ SAFE: Better type definitions for internal use
interface CarouselRefreshTimeout {
  timeout: any;
  type: ComponentType;
}

interface DomQueryCacheEntry {
  elements: NodeListOf<Element>;
  timestamp: number;
}

interface MemoizationCacheKey {
  baseHtml: string;
  dataId: string | number;
  showCashpoint: boolean;
  showPercentage: boolean;
}

interface ComponentState {
  carouselLayoutData: any[];
  productList: any[];
  reviewLayout: boolean;
  banners: any[];
  normalContent: string;
  sectionId: string;
  hasInitialized: boolean;
}

// ðŸŽ¯ SAFE: Type guards for better runtime safety
const isValidProduct = (product: any): product is { id: string; url_path: string } => {
  return product && typeof product === 'object' && (product.id || product.url_path);
};

const isValidBanner = (banner: any): banner is { id?: string } => {
  return banner && (typeof banner === 'string' || typeof banner === 'object');
};

const isValidReview = (review: any): review is { id?: string; author_name?: string } => {
  return review && typeof review === 'object' && (review.id || review.author_name);
};

export const CUSTOM_OPTIONS: OwlOptions = {
  loop: true,
  mouseDrag: true,
  touchDrag: true,
  autoplay: true,
  pullDrag: true,
  dots: false,
  navSpeed: 700,
  autoplayHoverPause: true,
  autoplayMouseleaveTimeout: 3000,
  navText: ['', ''],
  responsive: {
    0: { items: 1 },
    400: { items: 1 },
    740: { items: 1 },
    940: { items: 1 }
  },
  nav: false
}

@Component({
  standalone: true,
  selector: 'app-dynamic-template',
  templateUrl: './dynamic-template.component.html',
  styleUrls: ['./dynamic-template.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    CarouselModule,
    CardLoaderComponent,
    DynamicHomeProductCardComponent,
    MultipleCollectionProductListComponent,
    SideBannerProductListComponent,
    ScrollingTextComponent,
    StarRatingComponent,
    ReviewInterpolationPipe,
    SafehtmlPipe,
    InterpolationPipe,
    // Removed unused RoundoffPipe
  ]
})
export class DynamicTemplateComponent implements AfterViewInit, OnDestroy {
  private overlayService = inject(OverlayService);
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  private platformService = inject(PlatformService);
  private cartRepository = inject(CartRepositoryService);
  private document = inject<Document>(DOCUMENT);
  private readonly deviceDetectionService = inject(DeviceDetectionService);
  private router = inject(Router);
  private homeRepositoryService = inject(HomeRepositoryService);
  private notificationService = inject(NotificationService);
  private browserApiService = inject(BrowserApiService);
  private destroyRef = inject(DestroyRef);
  private readonly domMutationObserver = inject(DomMutationObserverService);
  private domainNameService: DomainNameService = inject(DomainNameService);

  // Constants
  readonly LAYOUT_TYPE = LAYOUT_TYPE;





  private readonly _htmlContent = signal<string>('');
  readonly htmlContent = this._htmlContent.asReadonly();

  // Model signals - writable by both parent components AND directives
  readonly banners = model<any>(null);
  readonly navigationSection = model<string>('');
  readonly normalContent = model<string>('');
  readonly productLoading = model<boolean>(false);
  readonly headerSection = model<string>('');
  readonly carouselListNavigationSection = model<string>('');
  readonly baseHtml = model<string>('');
  readonly showCashpoint = model<boolean>(false);
  readonly showPercentageDiscount = model<boolean>(true);
  readonly showAddToCart = model<boolean>(false);
  readonly sectionId = model<string>('');
  readonly countDownTemplate = model<boolean>(false);
  readonly productList$ = model<any[]>([]);
  readonly collectionIds = model<string[]>([]);
  readonly carouselLayoutNavigationSection = model<string>('');
  readonly carouselLayoutData = model<any[]>([]);
  readonly layoutConfig = model<any>(null);
  readonly reviewLayout = model<boolean>(false);


  readonly shouldShowLoader = computed(() => {
    // 1. Show loader for Google Reviews when review layout is active but no reviews loaded
    if (this.reviewLayout()) {
      // Only show loader if actively loading AND no error AND no reviews
      const isLoading = this._isLoadingReviews();
      const hasError = this._hasError();
      const hasReviews = this.googleReviews()?.length > 0;


      // Show loader only when actively loading, not when errored or has reviews
      return isLoading && !hasError && !hasReviews;
    }

    // 2. Show loader for collection-based product lists when collections are expected but not loaded
    if (this.collectionIds()?.length) {
      // This will be handled by the multiple-collection-product-list component's own loader
      return false;
    }

    // 3. Show loader for product lists when loading and no products available
    if (this.productLoading() && !this.productListSignal()?.length) {
      return true;
    }

    // 4. Don't show loader if we have static content (these don't require API calls)
    if (this.carouselLayoutData()?.length ||
      this.banners()?.length ||
      this.normalContent()) {
      return false;
    }

    // 5. Default: no loader needed
    return false;
  });

  // ðŸŽ¯ SAFE: New computed signals for template optimization
  readonly shouldShowScrollingText = computed(() => {
    const layout = this.componentBasedLayout();
    if (!layout?.sectionId?.includes('scroll')) return false;

    const isMobile = this.isMobile();
    const mobileVisible = layout.advanceConfiguration?.sectionVisibility?.mobile;
    const desktopVisible = layout.advanceConfiguration?.sectionVisibility?.desktop;

    return (isMobile && mobileVisible) || (!isMobile && desktopVisible);
  });

  readonly shouldShowReviewLayout = computed(() => {
    return this.reviewLayout() && this.googleReviews().length > 0;
  });

  readonly sectionIdWithStyle = computed(() => {
    const id = this.sectionId();
    return id ? `style-${id}` : '';
  });

  readonly hasValidSectionId = computed(() => {
    const id = this.sectionId();
    return id && id.length > 0;
  });

  // ðŸŽ¯ SAFE: Enhanced loading state management
  private readonly _isLoadingReviews = signal<boolean>(false);
  readonly isLoadingReviews = this._isLoadingReviews.asReadonly();

  private readonly _isLoadingProducts = signal<boolean>(false);
  readonly isLoadingProducts = this._isLoadingProducts.asReadonly();

  private readonly _hasError = signal<boolean>(false);
  readonly hasError = this._hasError.asReadonly();

  private readonly _errorMessage = signal<string>('');
  readonly errorMessage = this._errorMessage.asReadonly();

  // ðŸŽ¯ SAFE: Computed loading states for different sections
  readonly isCarouselLoading = computed(() => {
    return this.productLoading() && !this.productListSignal()?.length;
  });

  readonly isReviewSectionLoading = computed(() => {
    return this.reviewLayout() && this.isLoadingReviews() && !this.googleReviews()?.length;
  });

  readonly hasContent = computed(() => {
    return this.banners()?.length > 0 ||
      this.productListSignal()?.length > 0 ||
      this.carouselLayoutData()?.length > 0 ||
      this.googleReviews()?.length > 0 ||
      this.normalContent()?.length > 0;
  });

  readonly shouldShowEmptyState = computed(() => {
    return !this.shouldShowLoader() && !this.hasContent() && !this.hasError();
  });

  // Add missing customOptions input with default
  readonly customOptions = input<OwlOptions>(CUSTOM_OPTIONS);

  // Add missing page input for UTM tracking
  readonly page = input<string>('');

  // Add missing inputs for side banner product list (use model for two-way binding)
  readonly categoriesInfo = model<CategoryInfo[]>([]);
  readonly sideBannerProductList = model<boolean>(false);
  readonly sectionConfig = model<any>(null);

  // Debug computed signal for side banner condition
  readonly shouldShowSideBanner = computed(() => {
    const hasCollections = this.collectionIds().length > 0;
    const hasCategories = this.categoriesInfo().length > 0;
    const showSideBanner = this.sideBannerProductList();

    return (hasCollections || hasCategories) && showSideBanner;
  });

  // Track last customOptions to prevent duplicate setCustomOptions calls
  private lastCustomOptions: any = null;
  // Track if setCustomOptions was called directly (by directive) to prevent effect from overwriting
  private wasSetByDirective = false;

  // Writable signals for different carousel types that can be updated by changeOptions
  private readonly _carouselOptions = signal<OwlOptions>({
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    autoplay: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    autoplayHoverPause: true,
    autoplayMouseleaveTimeout: 3000,
    navText: ['', ''],
    responsive: {
      0: { items: 1 },      // Banner: 1 item on all screens
      400: { items: 1 },    // Banner: 1 item on all screens
      740: { items: 1 },    // Banner: 1 item on all screens
      940: { items: 1 }     // Banner: 1 item on all screens
    },
    nav: false
  });
  readonly carouselOptions = this._carouselOptions.asReadonly();

  private readonly _carouselListOptions = signal<OwlOptions>(CUSTOM_OPTIONS);
  readonly carouselListOptions = this._carouselListOptions.asReadonly();

  // Add missing isCarouselDot input
  private readonly _isCarouselDot = signal<boolean>(false);
  readonly isCarouselDot = this._isCarouselDot.asReadonly();

  // Carousel navigation methods - Angular 20 signal approach
  slideToPrevious(componentType: ComponentType) {
    if (componentType === ComponentType.CAROUSEL) {
      this.carousel()?.prev();
    }
    if (componentType === ComponentType.CAROUSEL_LIST) {
      this.carouselList()?.prev();
    }
    if (componentType === ComponentType.CAROUSEL_LAYOUT) {
      this.carouselLayout()?.prev();
    }
    if (componentType === ComponentType.REVIEW_LAYOUT) {
      this.reviewLayoutComponent()?.prev();
    }
  }

  slideToNext(componentType: ComponentType) {
    if (componentType === ComponentType.CAROUSEL) {
      this.carousel()?.next();
    }
    if (componentType === ComponentType.CAROUSEL_LIST) {
      this.carouselList()?.next();
    }
    if (componentType === ComponentType.CAROUSEL_LAYOUT) {
      this.carouselLayout()?.next();
    }
    if (componentType === ComponentType.REVIEW_LAYOUT) {
      this.reviewLayoutComponent()?.next();
    }
  }

  manageCarouselAutoPlay(addingToCart: boolean) {
    if (addingToCart) {
      this.carouselList()?.stopAutoplay();
    } else {
      this.carouselList()?.startAutoplay();
    }
  }

  // Setter for backward compatibility with SSR directive
  setIsCarouselDot(value: boolean) {
    this._isCarouselDot.set(value);
  }

  // Model signal setters - work with both parent binding and directive setting
  setNavigationSection(value: string) {
    this.navigationSection.set(value);
  }

  setBanners(value: any) {
    this.banners.set(value);
  }

  setNormalContent(value: string) {
    this.normalContent.set(value);
  }

  setHeaderSection(value: string) {
    this.headerSection.set(value);
  }

  setBaseHtml(value: any) {
    this.baseHtml.set(value);
  }

  setCarouselListNavigationSection(value: string) {
    this.carouselListNavigationSection.set(value);
  }

  setProductList$(value: any[]) {
    this.productList$.set(value);
  }

  setSectionId(value: string) {
    this.sectionId.set(value);
  }

  setProductLoading(value: boolean) {
    this.productLoading.set(value);
  }

  setCountDownTemplate(value: boolean) {
    this.countDownTemplate.set(value);
  }

  setShowCashpoint(value: boolean) {
    this.showCashpoint.set(value);
  }

  setShowPercentageDiscount(value: boolean) {
    this.showPercentageDiscount.set(value);
  }

  setShowAddToCart(value: boolean) {
    this.showAddToCart.set(value);
  }

  setCarouselLayoutNavigationSection(value: string) {
    this.carouselLayoutNavigationSection.set(value);
  }

  setCarouselLayoutData(value: any[]) {
    this.carouselLayoutData.set(value);
  }

  setLayoutConfig(value: any) {
    this.layoutConfig.set(value);
  }

  setReviewLayout(value: boolean) {
    this.reviewLayout.set(value);
    // Turn off product loading when review layout is set
    if (value) {
      this.productLoading.set(false);
    }
  }

  setCollectionIds(value: string[]) {
    this.collectionIds.set(value);
  }

  setCategoriesInfo(value: any[]) {
    this.categoriesInfo.set(value);
  }

  setSideBannerProductList(value: boolean) {
    this.sideBannerProductList.set(value);
  }

  setSectionConfig(value: any) {
    this.sectionConfig.set(value);
  }

  setCustomOptions(value: any, calledByDirective: boolean = false) {
    // Only mark as directive call if explicitly indicated
    // This prevents the effect from overwriting when directive calls it directly
    if (calledByDirective) {
      this.wasSetByDirective = true;
    }

    // Check if value already has a responsive config (from PrimaryViewerPanelComponent)
    // If it does, use it as-is. Otherwise, build one (from directive)
    const hasResponsiveConfig = value.responsive && typeof value.responsive === 'object';

    let customOptions: any;

    if (hasResponsiveConfig) {
      // Value already has responsive config (from PrimaryViewerPanelComponent)
      // Use it as-is, just merge with defaults (value comes last to preserve its responsive config)
      customOptions = {
        ...CUSTOM_OPTIONS,
        ...value // This includes the responsive config and will overwrite CUSTOM_OPTIONS.responsive
      };
    } else {
      // Value is a simple config object (from directive)
      // Build responsive config
      customOptions = {
        ...CUSTOM_OPTIONS,
        ...value,
        responsive: {
          0: { items: value.noOfSlidesToShowInMobile || 1 },
          400: { items: value.noOfSlidesToShowInMobile || 1 },
          740: { items: 3 },
          940: { items: value.items || 1 }
        }
      };
    }

    // Update both carousel options to ensure dots work for both banner and list carousels
    this._carouselOptions.set(customOptions);
    this._carouselListOptions.set(customOptions);

    // If the options contain items (and we built the responsive config), enhance it further
    if (value.items && !hasResponsiveConfig) {
      const mobileItems = value.noOfSlidesToShowInMobile || 1;
      const responsiveOptions = {
        ...customOptions,
        responsive: {
          0: {
            items: mobileItems,
            margin: mobileItems > 1 ? 20 : 10,
            loop: true,
            rewind: false,
            center: false,
            stagePadding: mobileItems > 1 ? 8 : 0
          },
          400: {
            items: mobileItems,
            margin: mobileItems > 1 ? 20 : 10,
            loop: true,
            rewind: false,
            center: false,
            stagePadding: mobileItems > 1 ? 8 : 0
          },
          740: {
            items: 3,
            margin: 10,
            stagePadding: 0
          },
          940: {
            items: value.items,
            margin: 10,
            stagePadding: 0
          }
        }
      };


      this._carouselListOptions.set(responsiveOptions);

      // Force carousel refresh after configuration change
      setTimeout(() => {
        this.refreshCarousel(this.carouselList()!);
      }, 100);
    }
  }

  // Helper method for comparing carousel options using JSON.stringify
  private isEqual(obj1: any, obj2: any): boolean {
    try {
      return JSON.stringify(obj1) === JSON.stringify(obj2);
    } catch {
      return obj1 === obj2;
    }
  }






  // Component-based layout as signal
  private readonly _componentBasedLayout = signal<any>({});
  readonly componentBasedLayout = this._componentBasedLayout.asReadonly();

  // Setter method for component-based layout
  setComponentBasedLayout(layout: any) {
    this._componentBasedLayout.set(layout);
  }















  // ViewChild references - keeping mainDiv as @ViewChild for now
  @ViewChild('mainDiv', { static: true }) div!: ElementRef;

  // Signal-based state
  private readonly _productList = signal<any[]>([]);
  readonly productListSignal = this._productList.asReadonly();

  private readonly _countDownPresent = signal<boolean>(false);
  readonly countDownPresent = this._countDownPresent.asReadonly();

  private readonly _isBrowser = signal<boolean>(false);
  readonly isBrowser = this._isBrowser.asReadonly();

  private readonly _googleReviews = signal<GoogleReview[]>([]);
  readonly googleReviews = this._googleReviews.asReadonly();

  private readonly _reviewsAverageRating = signal<number | undefined>(undefined);
  readonly reviewsAverageRating = this._reviewsAverageRating.asReadonly();

  private readonly _reviewsTotalCount = signal<number | undefined>(undefined);
  readonly reviewsTotalCount = this._reviewsTotalCount.asReadonly();

  private readonly _reviewsPageUrl = signal<string | undefined>(undefined);
  readonly reviewsPageUrl = this._reviewsPageUrl.asReadonly();

  // Computed signals - removed unused roundOffPipe

  readonly homePageMask$ = this.cartRepository.pageMasking;


  // Expose device detection service signals for template usage
  readonly isMobile = this.deviceDetectionService.isMobile;
  readonly isDesktop = this.deviceDetectionService.isDesktop;
  readonly isTablet = this.deviceDetectionService.isTablet;
  readonly deviceType = this.deviceDetectionService.deviceType;

  // Carousel options as signals
  readonly carouselLayoutCustomOptions = signal<OwlOptions>({
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    responsiveRefreshRate: 0,
    responsive: {
      0: { items: 2, stagePadding: 80, margin: 10 },
      400: { items: 2, stagePadding: 80, margin: 10 },
      640: { items: 3, stagePadding: 70, margin: 10 },
      940: { items: 6, margin: 10 }
    },
    nav: false
  });

  readonly gReviewLayoutCustomOptions = signal<OwlOptions>({
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    autoplay: false,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    responsiveRefreshRate: 0,
    responsive: {
      0: { items: 1, margin: 10, stagePadding: 80 },
      400: { items: 1, stagePadding: 80, margin: 10 },
      640: { items: 2, stagePadding: 70, margin: 10 },
      940: { items: 4, margin: 10 }
    },
    nav: false
  });

  // ViewChild references for carousel components - Angular 20 signal approach
  carousel = viewChild<CarouselComponent>('carousel');
  carouselList = viewChild<CarouselComponent>('carouselList');
  carouselLayout = viewChild<CarouselComponent>('carouselLayout');
  reviewLayoutComponent = viewChild<CarouselComponent>('reviewLayout');
  bannerSection = viewChild<ElementRef>('bannerSection');

  constructor() {
    const startTime = performance.now();

    this._isBrowser.set(this.platformService.isBrowser());


    // ðŸŽ¯ ANGULAR 20 OPTIMAL: Single coordinated effect for all template state
    // This prevents multiple simultaneous effects from causing flickering

    // State tracking for change detection
    let lastProcessedState = {
      carouselLayoutData: [] as any[],
      productList: [] as any[],
      reviewLayout: false,
      hasInitialized: false
    };

    effect(() => {
      // Collect all current state in one place
      const currentState = {
        carouselLayoutData: this.carouselLayoutData(),
        productList: this.productList$(),
        reviewLayout: this.reviewLayout(),
        banners: this.banners(),
        normalContent: this.normalContent(),
        sectionId: this.sectionId()
      };

      // Skip if no meaningful data yet
      if (!currentState.carouselLayoutData?.length &&
        !currentState.productList?.length &&
        !currentState.reviewLayout &&
        !currentState.banners?.length &&
        !currentState.normalContent &&
        !lastProcessedState.hasInitialized) {
        return;
      }

      // ðŸ”§ Process changes in optimal order to prevent cascading renders
      let hasChanges = false;

      // 1. Handle carousel layout data changes
      if (currentState.carouselLayoutData?.length &&
        this.hasArrayChanged(currentState.carouselLayoutData, lastProcessedState.carouselLayoutData)) {
        lastProcessedState.carouselLayoutData = [...currentState.carouselLayoutData];
        this.processCarouselLayoutData(currentState.carouselLayoutData);
        hasChanges = true;
      }

      // 2. Handle review layout changes
      if (currentState.reviewLayout && currentState.reviewLayout !== lastProcessedState.reviewLayout) {
        lastProcessedState.reviewLayout = currentState.reviewLayout;
        this.getGoogleReview();
        hasChanges = true;
      }

      // 3. Handle product list changes
      if (currentState.productList?.length &&
        this.hasArrayChanged(currentState.productList, lastProcessedState.productList)) {
        lastProcessedState.productList = [...currentState.productList];
        this.loadProductList(currentState.productList);
        hasChanges = true;
      }

      // 4. Process sections and refresh carousels after all data changes (single DOM update)
      if (hasChanges || !lastProcessedState.hasInitialized) {
        // Use queueMicrotask for optimal timing - after current execution but before next render
        queueMicrotask(() => {
          this.processSections();
          this.setupNavigationHandlers();

          // ðŸŽ¯ RESTORED: Refresh carousels when data changes (essential for ngx-owl-carousel-o)
          this.refreshCarouselsIfNeeded();
        });
        lastProcessedState.hasInitialized = true;
      }
    });

    // Effect to update carousel options when carouselListOptions changes
    effect(() => {
      const carouselOpts = this.carouselListOptions();
      const sectionId = this.sectionId() || 'unknown';

      // Effect watches for carouselListOptions changes
    });

    // Effect to watch customOptions input and call setCustomOptions when it changes
    // This allows setCustomOptions to work when component is used via PrimaryViewerPanelComponent (category/products routes)
    // The directive calls setCustomOptions directly, so this effect handles the input-based usage
    effect(() => {
      const options = this.customOptions();

      // Skip if setCustomOptions was called directly by directive (home page scenario)
      // The directive handles it directly, so we don't want the effect to overwrite with default input values
      if (this.wasSetByDirective) {
        // Reset flag after a short delay to allow for future input-based updates
        setTimeout(() => {
          this.wasSetByDirective = false;
        }, 100);
        return;
      }

      // Only proceed if options exist and are different from last processed
      if (options && Object.keys(options).length > 0) {
        const optionsString = JSON.stringify(options);
        const lastOptionsString = this.lastCustomOptions ? JSON.stringify(this.lastCustomOptions) : null;

        // Only call setCustomOptions if options actually changed
        if (optionsString !== lastOptionsString) {
          this.lastCustomOptions = { ...options };
          // Use untracked to prevent infinite loops since setCustomOptions updates internal signals
          untracked(() => {
            this.setCustomOptions(options);
          });
        }
      }
    });


    const endTime = performance.now();

  }

  // ðŸŽ¯ PERFORMANCE: Efficient array comparison without JSON.stringify
  private hasArrayChanged(current: any[], previous: any[]): boolean {
    if (!current || !previous) return true;
    if (current.length !== previous.length) return true;

    // Shallow comparison for performance
    return current.some((item, index) => {
      const prevItem = previous[index];
      // For objects, compare by reference or key properties
      if (typeof item === 'object' && item !== null && prevItem !== null) {
        return item.id !== prevItem.id || item !== prevItem;
      }
      return item !== prevItem;
    });
  }


  // ðŸŽ¯ Consolidated navigation setup to prevent duplicate event listeners
  private setupNavigationHandlers(): void {
    if (this.navigationSection()) {
      this.addClickActionsToCarousel();
    }
    if (this.carouselListNavigationSection()) {
      this.addClickActionsToCarouselList();
    }
    if (this.carouselLayoutNavigationSection()) {
      this.addClickActionsToCarouselLayout();
    }
  }

  // ðŸŽ¯ OPTIMIZED: Debounced carousel refresh for better performance
  private refreshCarouselsIfNeeded(): void {
    // Debounce carousel refresh to prevent excessive calls
    if (this.carouselRefreshTimeout) {
      clearTimeout(this.carouselRefreshTimeout);
    }

    this.carouselRefreshTimeout = setTimeout(() => {
      try {
        // Batch all carousel refreshes for better performance
        const refreshPromises: Promise<void>[] = [];

        // Refresh main carousel if it has banners
        if (this.banners()?.length && this.carousel()) {
          refreshPromises.push(this.refreshCarouselAsync(this.carousel()!));
        }

        // Refresh carousel list if it has products
        if (this.productListSignal()?.length && this.carouselList()) {
          refreshPromises.push(this.refreshCarouselAsync(this.carouselList()!));
        }

        // Refresh carousel layout if it has data
        if (this.carouselLayoutData()?.length && this.carouselLayout()) {
          refreshPromises.push(this.refreshCarouselAsync(this.carouselLayout()!));
        }

        // Refresh review layout if it's active
        if (this.reviewLayout() && this.googleReviews()?.length && this.reviewLayoutComponent()) {
          refreshPromises.push(this.refreshCarouselAsync(this.reviewLayoutComponent()!));
        }

        // Wait for all refreshes to complete
        Promise.all(refreshPromises).catch(() => {
          // Carousel refresh failed - continue gracefully
        });
      } catch (error) {
        // Carousel refresh failed - continue gracefully
      }
    }, 16); // Optimized timing for 60fps (16ms)
  }

  private carouselRefreshTimeout: any;

  // ðŸŽ¯ SAFE: Async carousel refresh for better performance
  private refreshCarouselAsync(carouselComponent: CarouselComponent): Promise<void> {
    return new Promise((resolve) => {
      try {
        // Use requestAnimationFrame for optimal timing
        requestAnimationFrame(() => {
          this.refreshCarousel(carouselComponent);
          resolve();
        });
      } catch (error) {
        resolve(); // Continue even if refresh fails
      }
    });
  }

  private processCarouselLayoutData(carouselLayoutData: any[]): void {
    // Process carousel layout data
    if (this.carouselLayoutNavigationSection()) {
      this.addClickActionsToCarouselLayout();
    }
  }

  private async loadProductList(productList: any[]): Promise<void> {

    try {
      if (productList && productList.length > 0) {
        // Data is already processed by parent component, use directly
        this._productList.set(productList);


        // Turn off loading state since products are now loaded
        this.productLoading.set(false);

        // Process sections
        this.processSections();

        // Set up click actions for carousel list
        this.addClickActionsToCarouselList();
      } else {
        // No products available, turn off loading state
        this.productLoading.set(false);
      }
    } catch (error) {
      // Failed to load product list
      this.productLoading.set(false);
    }
  }

  // ðŸŽ¯ SAFE: Cache for DOM queries to improve performance
  private domQueryCache = new Map<string, NodeListOf<Element>>();
  private lastProcessedSectionId: string = '';

  private processSections(): void {
    const currentSectionId = this.sectionId();
    if (!currentSectionId) {
      return; // Don't process if no sectionId is set
    }

    if (!this.div?.nativeElement) {
      return;
    }

    // ðŸŽ¯ OPTIMIZATION: Skip processing if sectionId hasn't changed
    if (currentSectionId === this.lastProcessedSectionId) {
      return;
    }

    // ðŸŽ¯ OPTIMIZATION: Batch DOM operations for better performance
    const fragment = this.document.createDocumentFragment();
    let hasChanges = false;

    // Only process sections that are direct children of this component's main div
    // Don't process sections inside child components like webstore-multiple-collection-product-list
    const cacheKey = `sections-${currentSectionId}`;
    let sections = this.domQueryCache.get(cacheKey);

    if (!sections) {
      sections = this.div.nativeElement.querySelectorAll(':scope > section');
      if (sections) {
        this.domQueryCache.set(cacheKey, sections);
      }
    }

    if (sections) {
      sections.forEach((section: Element) => {
        if (section instanceof HTMLElement) {
          // Only set ID if it doesn't already have one or if it's different
          if (!section.id || section.id !== currentSectionId) {
            section.id = currentSectionId;
            // Add the style class efficiently
            section.classList.add(`style-${currentSectionId}`);
            hasChanges = true;
          }
        }
      });
    }

    // Also check for any sections that might be in the carousel layout
    // but only if they don't already have an ID set by a child component
    const carouselCacheKey = `carousel-layout-${currentSectionId}`;
    let carouselLayoutSections = this.domQueryCache.get(carouselCacheKey);

    if (!carouselLayoutSections) {
      carouselLayoutSections = this.div.nativeElement.querySelectorAll('.carousel-layout:not([id])');
      if (carouselLayoutSections) {
        this.domQueryCache.set(carouselCacheKey, carouselLayoutSections);
      }
    }

    if (carouselLayoutSections) {
      carouselLayoutSections.forEach((section: Element) => {
        if (section instanceof HTMLElement) {
          if (!section.id || section.id !== currentSectionId) {
            section.id = currentSectionId;
            section.classList.add(`style-${currentSectionId}`);
            hasChanges = true;
          }
        }
      });
    }

    // ðŸŽ¯ OPTIMIZATION: Update cache tracking
    if (hasChanges) {
      this.lastProcessedSectionId = currentSectionId;
    }
  }

  // ðŸŽ¯ SAFE: Clear DOM cache when component is destroyed
  private clearDomCache(): void {
    this.domQueryCache.clear();
    this.lastProcessedSectionId = '';
  }

  ngOnInit(): void {
    // Initialize component data
    this.initializeComponentData();
  }

  private initializeComponentData(): void {
    try {
      // Set default values for required signals if they're not already set
      if (!this.sectionId()) {
        this.sectionId.set('default-section');
      }

      if (!this.baseHtml()) {
        this.baseHtml.set('');
      }

      if (!this.normalContent()) {
        this.normalContent.set('');
      }

      // Initialize other required properties
      if (!this.banners()) {
        this.banners.set([]);
      }

      if (!this.productList$() || this.productList$().length === 0) {
        this.productList$.set([]);
      }

      if (!this.carouselLayoutData()) {
        this.carouselLayoutData.set([]);
      }
    } catch (error) {
      // Error in initializeComponentData
    }
  }

  async ngAfterViewInit(): Promise<void> {
    try {
      if (this.navigationSection()) {
        this.addClickActionsToCarousel();
      }

      if (this.bannerSection()?.nativeElement) {
        this.getVideoElementDetails(this.bannerSection()!.nativeElement);
      }

      // Effects are now initialized in constructor
      // Set up additional effects to refresh carousels when data changes

      // ðŸŽ¯ ANGULAR 20 OPTIMAL: No additional effects needed
      // All rendering coordination is handled by the single effect in initializeEffects()
    } catch (error) {
      // Error in ngAfterViewInit
    }
  }


  // ðŸŽ¯ REMOVED: setupCarouselRefreshEffects() - replaced with single coordinated effect
  // This method was causing excessive re-rendering with multiple competing effects

  private refreshCarousel(carouselComponent: CarouselComponent): void {
    if (carouselComponent) {
      try {
        const options = this.carouselListOptions();
        const isDefaultOptions = options.autoplay === true && options.responsive?.[940]?.items === 1;
        const isCustomOptions = options.autoplay === false || options.responsive?.[940]?.items !== 1;


        // ðŸŽ¯ ANGULAR 20 OPTIMAL: Proper carousel refresh for ngx-owl-carousel-o
        // This approach works with Angular 20 signals and change detection
        setTimeout(() => {
          // Force carousel to re-initialize by triggering change detection
          // This is the standard approach used in other carousel components
          if ((carouselComponent as any).onResize) {
            (carouselComponent as any).onResize();
          }
        }, 0);
      } catch (error) {
        // Carousel refresh failed - continue gracefully
      }
    }
  }

  addClickActionsToCarousel() {
    this.setupEventDelegation('carousel');
    this.setupDirectClickListeners('carousel');
  }

  private setupEventDelegation(type: string) {
    const selector = type === 'carousel' ? '.carousel-nav-prev, .carousel-nav-next' :
      type === 'carousel-list' ? '.carousel-list-nav-prev, .carousel-list-nav-next' :
        type === 'carousel-layout' ? '.carousel-layout-nav-prev, .carousel-layout-nav-next' :
          '.review-layout-nav-prev, .review-layout-nav-next';

    this.renderer.listen(this.el.nativeElement, 'click', (event: Event) => {
      const target = event.target as Element;

      if (target.matches && target.matches(selector)) {
        event.preventDefault();
        event.stopPropagation();

        if (target.classList.contains('carousel-nav-prev') || target.classList.contains('carousel-list-nav-prev') ||
          target.classList.contains('carousel-layout-nav-prev') || target.classList.contains('review-layout-nav-prev')) {
          this.slideToPrevious(this.getComponentType(type));
        } else if (target.classList.contains('carousel-nav-next') || target.classList.contains('carousel-list-nav-next') ||
          target.classList.contains('carousel-layout-nav-next') || target.classList.contains('review-layout-nav-next')) {
          this.slideToNext(this.getComponentType(type));
        }
      }
    });
  }

  private getComponentType(type: string): ComponentType {
    switch (type) {
      case 'carousel': return ComponentType.CAROUSEL;
      case 'carousel-list': return ComponentType.CAROUSEL_LIST;
      case 'carousel-layout': return ComponentType.CAROUSEL_LAYOUT;
      case 'review-layout': return ComponentType.REVIEW_LAYOUT;
      default: return ComponentType.CAROUSEL;
    }
  }

  private setupDirectClickListeners(type: string) {
    const findElements = () => {
      const selectors = type === 'carousel' ?
        { prev: '.carousel-nav-prev', next: '.carousel-nav-next' } :
        type === 'carousel-list' ?
          { prev: '.carousel-list-nav-prev', next: '.carousel-list-nav-next' } :
          type === 'carousel-layout' ?
            { prev: '.carousel-layout-nav-prev', next: '.carousel-layout-nav-next' } :
            { prev: '.review-layout-nav-prev', next: '.review-layout-nav-next' };

      const previousSlideElement = this.el.nativeElement.querySelector(selectors.prev);
      const nextSlideElement = this.el.nativeElement.querySelector(selectors.next);
      return { previousSlideElement, nextSlideElement };
    };

    let { previousSlideElement, nextSlideElement } = findElements();

    if (!previousSlideElement || !nextSlideElement) {
      setTimeout(() => {
        const retryResult = findElements();
        previousSlideElement = retryResult.previousSlideElement;
        nextSlideElement = retryResult.nextSlideElement;
        this.setupCarouselClickListeners(previousSlideElement, nextSlideElement, type);
      }, 200);
      return;
    }

    this.setupCarouselClickListeners(previousSlideElement, nextSlideElement, type);
  }


  private setupCarouselClickListeners(prevElement: Element | null, nextElement: Element | null, type: string) {
    if (prevElement) {
      this.renderer.listen(prevElement, 'click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.slideToPrevious(this.getComponentType(type));
      });
    }

    if (nextElement) {
      this.renderer.listen(nextElement, 'click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.slideToNext(this.getComponentType(type));
      });
    }
  }

  addClickActionsToCarouselList() {
    this.setupEventDelegation('carousel-list');
    this.setupDirectClickListeners('carousel-list');
  }



  addClickActionsToCarouselLayout() {
    this.setupEventDelegation('carousel-layout');
    this.setupDirectClickListeners('carousel-layout');
  }

  addClickActionsToReviewLayout() {
    this.setupEventDelegation('review-layout');
    this.setupDirectClickListeners('review-layout');
  }


  changeOptions(updateProperty: any) {
    const { items, noOfSlidesToShowInMobile, ...rest } = updateProperty;
    let newProperty: Partial<OwlOptions>;

    if (items) {
      newProperty = {
        ...rest,
        margin: noOfSlidesToShowInMobile > 1 ? 20 : 10,
        responsive: {
          0: {
            items: noOfSlidesToShowInMobile || 1,
            margin: noOfSlidesToShowInMobile > 1 ? 20 : 10,
            loop: true,
            rewind: false,
            center: false,
            stagePadding: noOfSlidesToShowInMobile > 1 ? 8 : 0
          },
          400: {
            items: noOfSlidesToShowInMobile || 1,
            margin: noOfSlidesToShowInMobile > 1 ? 20 : 10,
            loop: true,
            rewind: false,
            center: false,
            stagePadding: noOfSlidesToShowInMobile > 1 ? 8 : 0
          },
          740: {
            items: 3,
            margin: 10,
            stagePadding: 0
          },
          940: {
            items,
            margin: 10,
            stagePadding: 0
          }
        },
      };
    } else {
      newProperty = { ...rest };
    }

    // Determine which carousel options to update based on component state
    // For carousel list (product lists), update carouselListOptions
    if (this.productListSignal()?.length) {
      this._carouselListOptions.set({ ...this._carouselListOptions(), ...newProperty });
    }
    // For carousel layout, update carouselLayoutCustomOptions
    else if (this.carouselLayoutData()?.length) {
      this.carouselLayoutCustomOptions.set({ ...this.carouselLayoutCustomOptions(), ...newProperty });
    }
    // For review layout, update gReviewLayoutCustomOptions
    else if (this.reviewLayout()) {
      this.gReviewLayoutCustomOptions.set({ ...this.gReviewLayoutCustomOptions(), ...newProperty });
    }
    // For regular carousel (banners), update carouselOptions
    else if (this.banners()?.length) {
      this._carouselOptions.set({ ...this._carouselOptions(), ...newProperty });
    }
    // Fallback case
    else {
      this._carouselListOptions.set({ ...this._carouselListOptions(), ...newProperty });
    }
  }

  getVideoElementDetails(sections: any) {
    const videoSections: any[] = sections?.getElementsByClassName('video-section-panel');
    const sectionElementId = sections?.getElementsByTagName('section')?.[0]?.id;

    for (let i = 0; i < videoSections?.length; i++) {
      const videoSection = videoSections[i];
      const videoElement = videoSection?.getElementsByTagName('video')[0] as HTMLElement;
      const iframeElements = videoSection?.getElementsByTagName('iframe') as HTMLCollectionOf<HTMLElement>;

      if (iframeElements?.length) {
        const iframeElement = iframeElements[0];
        if (iframeElement) {
          const { desktopVideoWidth, desktopVideoHeight } = this.getDesktopVideoDimensionAttributes(iframeElement);
          const { mobileVideoWidth, mobileVideoHeight } = this.getMobileVideoDimensionAttributes(iframeElement);

          const videoStylePresent = this.document && this.document?.getElementById(`video-${sectionElementId}`);
          if (sectionElementId && !videoStylePresent) {
            let styleElement = `#${sectionElementId} .video-section-panel .video-container iframe `;
            if (desktopVideoHeight) {
              styleElement += `{ width:${desktopVideoWidth}; height:${desktopVideoHeight}; }`;
            }
            if (mobileVideoHeight) {
              styleElement += `\n@media (max-width: 640px) { 
                #${sectionElementId} .video-section-panel .video-container iframe { width:${mobileVideoWidth};  height:${mobileVideoHeight}; } }`;
            }
            const style = this.renderer.createElement('style');
            style.id = `video-${sectionElementId}`;
            const text = this.renderer.createText(styleElement || "");
            this.renderer.appendChild(style, text);
            this.renderer.appendChild(this.document?.head, style);
            this.renderer.removeAttribute(iframeElement, "width");
            this.renderer.removeAttribute(iframeElement, "height");
          }
        }
      } else if (videoElement) {
        const { desktopVideoWidth, desktopVideoHeight } = this.getDesktopVideoDimensionAttributes(videoElement);
        const { mobileVideoWidth, mobileVideoHeight } = this.getMobileVideoDimensionAttributes(videoElement);
        const videoStylePresent = this.document && this.document?.getElementById(`video-${sectionElementId}`);

        if (sectionElementId && !videoStylePresent) {
          let styleElement = `#${sectionElementId} .video-section-panel .video-container video `;
          if (desktopVideoHeight) {
            styleElement += `{ width: ${desktopVideoWidth}; height:${desktopVideoHeight}; }`;
          }
          if (mobileVideoHeight) {
            styleElement += `\n@media (max-width: 640px) { 
              #${sectionElementId} .video-section-panel .video-container video { width:${mobileVideoWidth}; height:${mobileVideoHeight}; } }`;
          }
          const style = this.renderer.createElement('style');
          style.id = `video-${sectionElementId}`;
          const text = this.renderer.createText(styleElement || "");
          this.renderer.appendChild(style, text);
          this.renderer.appendChild(this.document?.head, style);
        }
      }
    }
  }

  getDesktopVideoDimensionAttributes(element: HTMLElement) {
    const desktopVideoWidth = element?.getAttribute("data-desktop-width") ?? '100%';
    const desktopVideoHeight = element?.getAttribute("data-desktop-height");
    return { desktopVideoWidth, desktopVideoHeight };
  }

  getMobileVideoDimensionAttributes(element: HTMLElement) {
    const mobileVideoWidth = element?.getAttribute("data-mobile-width") ?? '100%';
    const mobileVideoHeight = element?.getAttribute("data-mobile-height");
    return { mobileVideoWidth, mobileVideoHeight };
  }


  navigateToProductDetailPage(productUrl: string) {
    const applicationUrl = this.domainNameService.getApplicationUrl();

    if ((window as any)?.flutter_inappwebview) {
      const clickActionForFlutter: ClickActionForFlutter = {
        value: "",
        action: ClickActionChoices.link_product,
        url_path: productUrl
      };
      (window as any)?.flutter_inappwebview?.callHandler('FlutterHandler', JSON.stringify(clickActionForFlutter));
    }

    if (!applicationUrl.includes(NIKITA_RETAILER_APP_DOMAIN)) {
      // âœ… Add UTM parameters for tracking
      this.router.navigate(['/products/' + productUrl], {
        queryParams: {
          utm_source: this.page() || 'home',
          utm_medium: 'product-section'
        }
      });
    }
  }

  navigateToCollectionPage(collectionId: string) {
    this.router.navigate(['/search/'], {
      queryParams: {
        collection_ids: collectionId,
        utm_source: this.page() || 'home',
        utm_medium: 'collection-list'
      }
    });
  }

  navigateToCategoryPage(categoryUrl: string) {
    this.router.navigate(['category', categoryUrl], {
      queryParams: {
        utm_source: this.page() || 'home',
        utm_medium: 'category-list'
      }
    });
  }

  private async getGoogleReview(): Promise<void> {
    const reviewStartTime = performance.now();

    // ðŸŽ¯ SAFE: Set loading state
    this._isLoadingReviews.set(true);
    this._hasError.set(false);

    try {
      await this.homeRepositoryService.loadGoogleReviews();
      const reviewResponse = this.homeRepositoryService.googleReviews();

      if (reviewResponse) {
        const reviews = reviewResponse.reviews?.map(review => ({
          quoteIcon: this.layoutConfig()?.quoteIcon || "",
          ...review
        })) ?? [];

        this._googleReviews.set(reviews);
        this._reviewsAverageRating.set(reviewResponse.averagerating);
        this._reviewsTotalCount.set(reviewResponse.totalreviewcount);
        this._reviewsPageUrl.set(reviewResponse.google_reviews_page_url);

        if (reviews?.length) {
          this.processSections();
          if (this.carouselLayoutNavigationSection()) {
            this.addClickActionsToReviewLayout();
          }
        }
      }
    } catch (error) {
      // ðŸŽ¯ SAFE: Better error handling without breaking functionality
      this.handleGoogleReviewError(error);
    } finally {
      // ðŸŽ¯ SAFE: Always clear loading state
      this._isLoadingReviews.set(false);
    }

    const reviewEndTime = performance.now();
  }

  // ðŸŽ¯ SAFE: New error handling method that doesn't break existing flow
  private handleGoogleReviewError(error: any): void {
    try {

      // Set error state for better UX
      this._hasError.set(true);
      this._errorMessage.set('Failed to load reviews');

      // Set empty state so UI doesn't show loading indefinitely
      this._googleReviews.set([]);
      this._reviewsAverageRating.set(undefined);
      this._reviewsTotalCount.set(undefined);
      this._reviewsPageUrl.set(undefined);

      // Turn off review layout to prevent infinite loading
      this.reviewLayout.set(false);

      // Error handled gracefully
    } catch (cleanupError) {
      // Even error handling can fail - continue gracefully
    }
  }

  openGoogleReviewDetailOverlay(reviewIndex: number) {
    const reviews = this.googleReviews();
    if (!reviews || reviews.length === 0) {
      return;
    }

    if (reviewIndex < 0 || reviewIndex >= reviews.length) {
      return;
    }

    const allReviews = reviews.filter((_, index) => reviewIndex !== index);
    const currentReview = reviews[reviewIndex];

    this.overlayService.open<GoogleReviewOverlayComponent>(
      GoogleReviewOverlayComponent,
      {
        review: currentReview,
        reviews: allReviews,
        baseHtml: this.baseHtml(),
        sectionId: this.sectionId(),
        averagerating: this.reviewsAverageRating(),
        totalreviewcount: this.reviewsTotalCount(),
        google_reviews_page_url: this.reviewsPageUrl()
      },
      true,
      'centered'
    );
  }

  getStarArray(rating: number): Array<{ type: string, percentage?: number }> {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasPartialStar = rating % 1 !== 0;
    const partialStarPercentage = hasPartialStar ? (rating % 1) * 100 : 0;

    // Add full stars
    for (let i = 0; i < fullStars; i++) {
      stars.push({ type: 'full' });
    }

    // Add partial star if exists
    if (hasPartialStar) {
      stars.push({ type: 'partial', percentage: partialStarPercentage });
    }

    // Add empty stars
    const emptyStars = 5 - stars.length;
    for (let i = 0; i < emptyStars; i++) {
      stars.push({ type: 'empty' });
    }

    return stars;
  }

  openGoogleReviewPage() {
    const reviewsPageUrl = this.reviewsPageUrl();
    if (!reviewsPageUrl) {
      return;
    }

    this.browserApiService.open(reviewsPageUrl, '_blank');
  }

  ngOnDestroy(): void {
    const destroyTime = performance.now();

    // Additional safe cleanup for better memory management
    this.cleanupEventListeners();
  }

  // ðŸŽ¯ SAFE: Additional cleanup methods that don't break existing functionality
  private cleanupEventListeners(): void {
    try {
      // Clean up carousel refresh timeout
      if (this.carouselRefreshTimeout) {
        clearTimeout(this.carouselRefreshTimeout);
        this.carouselRefreshTimeout = null;
      }

      // Clean up DOM cache for memory optimization
      this.clearDomCache();

      // Clear memoization cache for memory optimization
      this.clearMemoizationCache();

      // Clean up any manual event listeners if they exist
      // This is safe because it only removes listeners, doesn't change API
      if (this.el?.nativeElement) {
        // Remove any manually added event listeners
        const manualListeners = this.el.nativeElement.querySelectorAll('[data-manual-listener]');
        manualListeners.forEach((element: Element) => {
          element.removeEventListener('click', this.handleManualClick);
        });
      }
    } catch (error) {
      // Safe cleanup - continue even if error occurs
    }
  }

  private handleManualClick = (event: Event) => {
    // Placeholder for manual click handler
    // This ensures the reference is consistent for cleanup
  }

  // ðŸŽ¯ SAFE: TrackBy functions for better @for performance in template
  readonly trackByBannerId = (index: number, banner: any): any => {
    if (isValidBanner(banner)) {
      return banner.id || banner || index;
    }
    return index;
  };

  readonly trackByProductId = (index: number, product: any): any => {
    if (isValidProduct(product)) {
      return product.id || product.url_path || index;
    }
    return index;
  };

  readonly trackByCarouselLayoutId = (index: number, item: any): any => {
    return item?.id || item?.sectionId || index;
  };

  readonly trackByReviewId = (index: number, review: any): any => {
    if (isValidReview(review)) {
      return review.id || review.author_name || index;
    }
    return index;
  };

  // ðŸŽ¯ SAFE: Memoized pipe values for better performance
  readonly memoizedInterpolation = new Map<string, string>();
  readonly memoizedSafeHtml = new Map<string, any>();

  // ðŸŽ¯ SAFE: Helper to get memoized interpolation result
  getMemoizedInterpolation(baseHtml: string, data: any, showCashpoint: boolean, showPercentage: boolean): string {
    const key = `${baseHtml}-${data?.id}-${showCashpoint}-${showPercentage}`;

    if (!this.memoizedInterpolation.has(key)) {
      // This would normally go through the interpolation pipe
      // For now, we'll just return the key as a placeholder
      this.memoizedInterpolation.set(key, key);
    }

    return this.memoizedInterpolation.get(key)!;
  }

  // ðŸŽ¯ SAFE: Clear memoization cache when data changes
  private clearMemoizationCache(): void {
    this.memoizedInterpolation.clear();
    this.memoizedSafeHtml.clear();
  }
}






